(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dino-stomp-landing-desktop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-dino-carousel]').forEach((carousel) => {
        if (carousel.dataset.ready === 'true') return;
        carousel.dataset.ready = 'true';
        const dialog = carousel.querySelector('[data-carousel-dialog]');
        const dialogImage = carousel.querySelector('[data-dialog-image]');

        carousel.querySelectorAll('[data-mode-input]').forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) carousel.dataset.mode = input.value;
          });
        });

        const openDialog = (slide) => {
          if (!dialog || !dialogImage || !slide) return;
          const mode = carousel.dataset.mode || 'line';
          const image = slide.querySelector(`[data-variant="${mode}"]`);
          if (!image) return;
          dialogImage.src = image.currentSrc || image.src;
          dialogImage.alt = image.alt || '';
          if (typeof dialog.showModal === 'function') dialog.showModal();
        };

        carousel.querySelectorAll('[data-enlarge]').forEach((trigger) => {
          trigger.addEventListener('click', () => openDialog(trigger.closest('[data-slide]')));
          trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openDialog(trigger.closest('[data-slide]'));
            }
          });
        });

        const close = carousel.querySelector('[data-dialog-close]');
        if (close && dialog) close.addEventListener('click', () => dialog.close());
        if (dialog) dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dino-stomp-landing-mobile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-dino-carousel]').forEach((carousel) => {
        if (carousel.dataset.ready === 'true') return;
        carousel.dataset.ready = 'true';
        const track = carousel.querySelector('[data-carousel-track]');
        const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-dot]'));
        const currentPage = carousel.querySelector('[data-current-page]');
        const dialog = carousel.querySelector('[data-carousel-dialog]');
        const dialogImage = carousel.querySelector('[data-dialog-image]');
        let activeIndex = 0;
        let scrollFrame;

        const update = (index) => {
          activeIndex = Math.max(0, Math.min(index, slides.length - 1));
          if (currentPage) currentPage.textContent = String(activeIndex + 1);
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        };

        const goTo = (index) => {
          const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
          if (!target || !track) return;
          track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          update(index);
        };

        carousel.querySelectorAll('[data-mode-input]').forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) carousel.dataset.mode = input.value;
          });
        });

        dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

        if (track) {
          track.addEventListener('scroll', () => {
            cancelAnimationFrame(scrollFrame);
            scrollFrame = requestAnimationFrame(() => {
              const positions = slides.map((slide) => Math.abs((slide.offsetLeft - track.offsetLeft) - track.scrollLeft));
              const closest = positions.indexOf(Math.min(...positions));
              if (closest >= 0) update(closest);
            });
          }, { passive: true });
        }

        const openDialog = (slide) => {
          if (!dialog || !dialogImage || !slide) return;
          const mode = carousel.dataset.mode || 'line';
          const image = slide.querySelector(`[data-variant="${mode}"]`);
          if (!image) return;
          dialogImage.src = image.currentSrc || image.src;
          dialogImage.alt = image.alt || '';
          if (typeof dialog.showModal === 'function') dialog.showModal();
        };

        carousel.querySelectorAll('[data-enlarge]').forEach((trigger) => {
          trigger.addEventListener('click', () => openDialog(trigger.closest('[data-slide]')));
          trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openDialog(trigger.closest('[data-slide]'));
            }
          });
        });

        const close = carousel.querySelector('[data-dialog-close]');
        if (close && dialog) close.addEventListener('click', () => dialog.close());
        if (dialog) dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        update(0);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dino-stomp-landing-tablet"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-dino-carousel]').forEach((carousel) => {
        if (carousel.dataset.ready === 'true') return;
        carousel.dataset.ready = 'true';
        const dialog = carousel.querySelector('[data-carousel-dialog]');
        const dialogImage = carousel.querySelector('[data-dialog-image]');
        const track = carousel.querySelector('[data-carousel-track]');
        const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));

        const setActiveDot = (index) => {
          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === index;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };

        const closestSlideIndex = () => {
          if (!track || slides.length === 0) return 0;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          return closestIndex;
        };

        let scrollFrame;
        if (track && dots.length > 0) {
          track.addEventListener('scroll', () => {
            window.cancelAnimationFrame(scrollFrame);
            scrollFrame = window.requestAnimationFrame(() => setActiveDot(closestSlideIndex()));
          }, { passive: true });
          dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              const index = Number(dot.dataset.index);
              const slide = slides[index];
              if (slide) {
                setActiveDot(index);
                track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
              }
            });
          });
        }

        carousel.querySelectorAll('[data-mode-input]').forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) carousel.dataset.mode = input.value;
          });
        });

        const openDialog = (slide) => {
          if (!dialog || !dialogImage || !slide) return;
          const mode = carousel.dataset.mode || 'line';
          const image = slide.querySelector(`[data-variant="${mode}"]`);
          if (!image) return;
          dialogImage.src = image.currentSrc || image.src;
          dialogImage.alt = image.alt || '';
          if (typeof dialog.showModal === 'function') dialog.showModal();
        };

        carousel.querySelectorAll('[data-enlarge]').forEach((trigger) => {
          trigger.addEventListener('click', () => openDialog(trigger.closest('[data-slide]')));
          trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openDialog(trigger.closest('[data-slide]'));
            }
          });
        });

        const close = carousel.querySelector('[data-dialog-close]');
        if (close && dialog) close.addEventListener('click', () => dialog.close());
        if (dialog) dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
